// extracted by mini-css-extract-plugin
export default {"badgeContainer":"styles_badgeContainer__FnKf0","dot":"styles_dot__g6x1w","danger":"styles_danger__mDMLf","success":"styles_success__I8yqE"};